import React from 'react';
import { Button, Checkbox, FormGroup, FormControl } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import { shuffleFisherYates } from '../util/Helper';
import { Link } from 'react-router-dom';
import AccessibleLink from './AccessibleLink';

const Form = ({
  ballotData,
  user,
  studentInfo,
  votes,
  setVotes,
  showElectionHeading = true,
  submitButtonLabel = 'Submit',
  submitButtonType = 'submit',
  onSubmitButtonClick,
}) => {
  let history = useHistory();

  /* submit votes and go to confirmation, votes are not saved yet */
  const onSubmit = (e) => {
    e.preventDefault();
    // todo - send data somewhere
    history.push({
      pathname: '/confirm',
      state: {
        // location state
        votes: votes,
        ballotData: ballotData,
        studentInfo: studentInfo,
        studentVoted: true,
      },
    });
  };

  /* Check that number of selections do not exceed limit */
  const handleChangeChecked = function (
    ballotId,
    e,
    writeIn,
    writeInId,
    numberChosen
  ) {
    let ballot = votes.allBallots;
    const count = ballot.reduce(
      (acc, cur) =>
        parseInt(cur.BallotId) === parseInt(ballotId) ? ++acc : acc,
      0
    );
    const count_writein = ballot.reduce(
      (acc, cur) =>
        parseInt(cur.BallotId) === parseInt(ballotId) && cur.WriteIn
          ? ++acc
          : acc,
      0
    );
    //remove non selected
    if (!writeIn && !e.target.checked) {
      let index = ballot.findIndex(
        (obj) =>
          obj.BallotId === ballotId &&
          obj.BallotCandidateId === parseInt(e.target.value)
      );
      if (index !== -1) {
        ballot.splice(index, 1);
      }
    }

    if (count >= numberChosen) {
      if (writeIn) {
        let index = ballot.findIndex(
          (obj) => obj.BallotId === ballotId && obj.write_in_id === writeInId
        );
        if (index < 0) {
          e.target.value = '';
        } else {
          if (e.target.value !== '') {
            ballot[index] = {
              BallotId: ballotId,
              CandidateName: e.target.value,
              BallotCandidateId: null,
              WriteIn: writeIn,
              write_in_id: writeInId,
            };
          } else {
            ballot.splice(index, 1);
          }
        }
      } else {
        e.target.checked = false;
      }
    } else {
      if (writeIn && count_writein < numberChosen) {
        if (ballot.length) {
          let index = ballot.findIndex(
            (obj) =>
              obj.BallotId === ballotId &&
              obj.BallotCandidateId === null &&
              obj.write_in_id === writeInId
          );
          if (index < 0) {
            ballot.push({
              BallotId: ballotId,
              CandidateName: e.target.value,
              BallotCandidateId: null,
              WriteIn: writeIn,
              write_in_id: writeInId,
            });
          } else {
            ballot[index] = {
              BallotId: ballotId,
              CandidateName: e.target.value,
              BallotCandidateId: null,
              WriteIn: writeIn,
              write_in_id: writeInId,
            };
          }
        } else {
          ballot.push({
            BallotId: ballotId,
            CandidateName: e.target.value,
            BallotCandidateId: null,
            WriteIn: writeIn,
            write_in_id: writeInId,
          });
        }
      } else {
        if (e.target.checked) {
          if (ballot.length) {
            let index = ballot.findIndex(
              (obj) =>
                obj.BallotId === ballotId &&
                obj.BallotCandidateId === parseInt(e.target.value)
            );
            if (index < 0) {
              ballot.push({
                BallotId: ballotId,
                CandidateName: null,
                BallotCandidateId: parseInt(e.target.value),
                WriteIn: writeIn,
              });
            }
          } else {
            ballot.push({
              BallotId: ballotId,
              CandidateName: null,
              BallotCandidateId: parseInt(e.target.value),
              WriteIn: writeIn,
            });
          }
        } else {
          let index = ballot.findIndex(
            (obj) =>
              obj.BallotId === ballotId &&
              obj.BallotCandidateId === parseInt(e.target.value)
          );
          if (index !== -1) {
            ballot.splice(index, 1);
          }
        }
      }
    }

    let thisVote = votes;
    thisVote.allBallots = ballot;
    setVotes(thisVote);
  };

  /* Show write ins */
  const ShowWriteIn = (data) => {
    let elements = [];
    for (let i = 1; i <= data.ballot.numberChosen; i++) {
      elements.push(
        <React.Fragment key={'write_in_group_' + i + '_' + data.ballot.ballotId}>
          <FormControl
            type='text'
            placeholder={'Write In #' + i}
            name={'write_' + i + '_' + data.ballot.ballotId}
            id={'write_' + i + '_' + data.ballot.ballotId}
            aria-label={`Write-in candidate ${i} for ${data.ballot.ballotName}`}
            defaultValue={writeInValue(
              votes.allBallots,
              i,
              data.ballot.ballotId
            )}
            onChange={(e) =>
              handleChangeChecked(
                data.ballot.ballotId,
                e,
                1,
                'write_' + i + '_' + data.ballot.ballotId,
                data.ballot.numberChosen
              )
            }
          />
          <br />
        </React.Fragment>
      );
    }
    return elements;
  };

  /* saved votes from back navigation */
  const checkExists = (arrObjects, value, elType) => {
    if (typeof arrObjects !== 'undefined') {
      return arrObjects.some(function (el) {
        return el[elType] === value;
      })
        ? 'checked'
        : '';
    } else {
      return;
    }
  };

  /* Get value of write in candidate */
  const writeInValue = (arrObjects, i, ballotId) => {
    const valObj = arrObjects.filter((el) => {
      return el.write_in_id === 'write_' + i + '_' + ballotId;
    })[0];
    return valObj ? valObj.CandidateName : '';
  };

  const NewlineText = (props) => {
    const text = props.text;
    return <div id={props.id} className='ballot-detail-display'>{text}</div>;
  };

  const hasBallotCandidates =
    ballotData &&
    Array.isArray(ballotData.allBallots) &&
    ballotData.allBallots.length > 0 &&
    Array.isArray(ballotData.allBallots[0].allCandidates);

  return hasBallotCandidates ? (
    <form onSubmit={onSubmit}>
      {showElectionHeading ? <h1>{ballotData.electionName}</h1> : null}
      {ballotData.allBallots.map((ballot) => {
        if (
          ballot.ballotRestrictionTypeId === 1 ||
          (ballot.ballotRestrictionTypeId === 2 &&
            studentInfo.classLevel === ballot.ballotRestrictionDetail) ||
          (parseInt(ballot.ballotRestrictionTypeId) === 3 &&
            studentInfo.classLevel !== 'G' &&
            studentInfo.allColleges.some(
              (college) => college.coll === ballot.ballotRestrictionDetail
            )) ||
          (ballot.ballotRestrictionTypeId === 4 &&
            studentInfo.residential === ballot.ballotRestrictionDetail)
        ) {
          const ballotDetailId = ballot.referendum && ballot.ballotDetail
            ? 'ballot_detail_' + ballot.ballotId
            : null;
          const ballotInstructionsId = 'ballot_instructions_' + ballot.ballotId;
          const ballotDescriptionIds = ballotDetailId
            ? ballotInstructionsId + ' ' + ballotDetailId
            : ballotInstructionsId;

          return (
            <React.Fragment key={ballot.ballotId}>
              <h2 className='h3'>{ballot.ballotName}</h2>
              <fieldset
                className='ballot-fieldset'
                aria-describedby={ballotDescriptionIds}
              >
                <legend className='sr-only'>{ballot.ballotName}</legend>
                {ballot.referendum && ballot.ballotDetail ? (
                  <NewlineText id={ballotDetailId} text={ballot.ballotDetail} />
                ) : (
                  ''
                )}
                <div
                  id={ballotInstructionsId}
                  className='ballot-group-instructions'
                >
                  You may vote for{' '}
                  <b>
                    {ballot.numberChosen > 1
                      ? 'up to ' + ballot.numberChosen
                      : 'one'}
                  </b>{' '}
                  of the following choices
                  {ballot.writeIn ? ' or write-in' : ''}.
                </div>
                <FormGroup>
                {shuffleFisherYates(ballot.allCandidates || []).map((candidate) => {
                  return (
                    <Checkbox
                      key={'key_' + candidate.ballotCandidateId}
                      className='ballot-candidate-row'
                      name={'checkboxGroup_' + ballot.ballotId}
                      value={candidate.ballotCandidateId}
                      defaultChecked={
                        !!checkExists(
                          votes.allBallots,
                          candidate.ballotCandidateId,
                          'BallotCandidateId'
                        )
                      }
                      onChange={(e) =>
                        handleChangeChecked(
                          ballot.ballotId,
                          e,
                          0,
                          0,
                          ballot.numberChosen
                        )
                      }
                    >
                      <div style={{ marginLeft: '12px' }}>
                        {candidate.ballotCandidateName}{' '}
                        {!ballot.referendum
                          ? ' - ' +
                            (candidate.ballotCandidatePartyName
                              ? candidate.ballotCandidatePartyName
                              : 'Independent')
                          : ''}
                        {candidate.profileApproved ? (
                          <span style={{ marginLeft: '60px' }}>
                            <p>
                              <AccessibleLink
                                component={Link}
                                aria-label={`View candidate statement for ${candidate.ballotCandidateName}`}
                                description={`Opens the candidate statement for ${candidate.ballotCandidateName} in a new browser tab.`}
                                to={`/candidate/${candidate.ballotCandidateId}`}
                                target='_blank'
                                rel='noopener noreferrer'
                              >
                                <b>[Candidate Statement]</b>
                              </AccessibleLink>
                            </p>
                          </span>
                        ) : (
                          ''
                        )}
                      </div>
                    </Checkbox>
                  );
                })}
                {ballot.writeIn && !ballot.referendum ? (
                  <ShowWriteIn ballot={ballot} />
                ) : (
                  ''
                )}
                </FormGroup>
              </fieldset>
            </React.Fragment>
          );
        } else return false;
      })}
      <hr />
      <Button
        className='btn btn-default'
        type={submitButtonType}
        onClick={onSubmitButtonClick}
      >
        {submitButtonLabel}
      </Button>
      <hr />
    </form>
  ) : (
    'Loading...'
  );
};
export default Form;
